angular.module('tgaApp').config(['$animateProvider',
  function ($animateProvider) {
    $animateProvider.classNameFilter(/angular-animate/);
  }]);
